const albums2023 = [
  {
    id: 1,
    title: {
      english: "State Level Bhajan Competition 2022-2023",
      marathi: "राज्यस्तरीय भजन स्पर्धा २०२२-२०२३"
    },
    year: 2023,
    photos: [
      {
        id: 1,
        title: {
          english: "First place winner group Amravati's Workers' Men's Team 2023",
          marathi: "प्रथम क्रमांक विजेता गट अमरावतीचा कामगार पुरुष संघ २०२३"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-01.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-01.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-01.jpg"
      },
      {
        id: 2,
        title: {
          english: "First place winner group Nagpur 1 women's team performing bhajan 2023",
          marathi: "प्रथम क्रमांक विजेता गट नागपूर १ चा महिला संघ भजन सादर करताना २०२३"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-02.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-02.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-02.jpg"
      },
      {
        id: 3,
        title: {
          english: "Group Amravati's men's team accepting the award for the first place in the male labor division",
          marathi: "प्रथम क्रमांकाचे कामगार पुरुष विभागाचे पारितोषिक स्वीकारताना गट अमरावतीचा पुरुष संघ"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-03.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-03.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-03.jpg"
      },
      {
        id: 4,
        title: {
          english: "Group Nagpur Women's Association accepting the first place women's division award",
          marathi: "प्रथम क्रमांकाचे महिला विभागाचे पारितोषिक स्वीकारताना गट नागपूर महिला संघ"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-04.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-04.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-04.jpg"
      },
      {
        id: 5,
        title: {
          english: "On the occasion of the inauguration of the competition, Principal Secretary of the Labour Department, Hon. Mrs. Vinita Ved-Singal, Lokmat Media Private Ltd. Vice President of Human Resources Department, Mr. Balaji Mule, Resident Editor of Sakal, Mr. Dayanand Mane and Hon. Welfare Commissioner Raviraj Ilve and other dignitaries were present.",
          marathi: "स्पर्धेच्या उद्घाटनप्रसंगी कामगार विभागाच्या प्रधान सचिव मा.श्रीमती विनिता वेद-सिंगल, लोकमत मीडिया प्रायव्हेट लि. मानव संसाधन विभागाचे उपाध्यक्ष श्री.बालाजी मुळे, सकाळचे निवासी संपादक श्री.दयानंद माने व मा.कल्याण आयुक्त रविराज इळवे आदी मान्यवर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-05.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-05.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/05/2023-05-05.jpg"
      }
    ]
  },
  {
    id: 2,
    title: {
      english: "Inauguration of Rifle Shooting Range and Archery Training Center",
      marathi: "रायफल शूटिंग रेंज आणि आर्चरी ट्रेनिंग सेंटरचे उद्घाटन"
    },
    year: 2023,
    photos: [
      {
        id: 1,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-01.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-01.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-01.jpg"
      },
      {
        id: 2,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-02.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-02.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-02.jpg"
      },
      {
        id: 3,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-03.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-03.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-03.jpg"
      },
      {
        id: 4,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-04.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-04.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-04.jpg"
      },
      {
        id: 5,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-05.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-05.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-05.jpg"
      },
      {
        id: 6,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-06.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-06.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-06.jpg"
      },
      {
        id: 7,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-07.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-07.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-07.jpg"
      },
      {
        id: 8,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-08.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-08.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-08.jpg"
      },
      {
        id: 9,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-09.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-09.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-09.jpg"
      },
      {
        id: 10,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-10.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-10.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-10.jpg"
      },
      {
        id: 11,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-11.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-11.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-01-11.jpg"
      }
    ]
  },
  {
    id: 3,
    title: {
      english: "State Level Open Kabaddi Competition for Industrial and Professional Workers and Women 2022 - 2023",
      marathi: "राज्यस्तरीय औद्योगिक व व्यावसायिक कामगार व महिलांसाठी खुली कबड्डी स्पर्धा २०२२ - २०२३"
    },
    year: 2023,
    photos: [
      {
        id: 1,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-01.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-01.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-01.jpg"
      },
      {
        id: 2,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-02.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-02.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-02.jpg"
      },
      {
        id: 3,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-03.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-03.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-03.jpg"
      },
      {
        id: 4,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-04.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-04.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-04.jpg"
      },
      {
        id: 5,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-05.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-05.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-05.jpg"
      },
      {
        id: 6,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-06.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-06.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-06.jpg"
      },
      {
        id: 7,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-07.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-07.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-07.jpg"
      },
      {
        id: 8,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-08.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-08.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-08.jpg"
      },
      {
        id: 9,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-09.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-09.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-09.jpg"
      },
      {
        id: 10,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-10.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-10.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-02-10.jpg"
      }
    ]
  },
  {
    id: 4,
    title: {
      english: "State Level Workers Kesari and Kumar Kesari Wrestling Competition 2022 - 2023",
      marathi: "राज्यस्तरीय कामगार केसरी व कुमार केसरी कुस्ती स्पर्धा २०२२ - २०२३"
    },
    year: 2023,
    photos: [
      {
        id: 1,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-01.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-01.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-01.jpg"
      },
      {
        id: 2,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-02.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-02.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-02.jpg"
      },
      {
        id: 3,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-03.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-03.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-03.jpg"
      },
      {
        id: 4,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-04.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-04.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-04.jpg"
      },
      {
        id: 5,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-05.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-05.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-05.jpg"
      },
      {
        id: 6,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-06.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-06.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-06.jpg"
      },
      {
        id: 7,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-07.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-07.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-07.jpg"
      },
      {
        id: 8,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-08.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-08.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-08.jpg"
      },
      {
        id: 9,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-09.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-09.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2023/04/2023-04-03-09.jpg"
      }
    ]
  }
];

export default albums2023;
